// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"Q3-z"};